import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import {
  EntryType,
  NavbarType,
  RouterLinks,
  SectionType,
} from '../../constants';
import { combineLatest, Subscription } from 'rxjs';
import { Location, TitleCasePipe } from '@angular/common';
import { PolicyQuery } from '../../../policy/state/policy.query';
import { UnderwriterQuery } from '../../../underwriter/state/underwriter.query';
import { UnderwriterSchedule } from '../../models/underwriter.model';
import { RouterQuery } from '@datorama/akita-ng-router-store';
import { environment } from '../../../../../environments/environment';
import { PolicyScheduleQuery } from '../../../policy/state/policy-schedule.query';
import { UserStore } from '../../../authentication/state/user.store';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import { ComponentsService } from '../../services/components-service';
import { QuestionStore } from '../../questions/state/question.store';
import { GlobalQuestionService } from '../../services/global-question.service';
import { ClaimStore } from 'src/app/modules/claim/state/state/claims-session.store';
import { ClaimGuardService } from '../../services/claim-guard.service';
import { FlowPlayerService } from '../../services/flow-player.service';
import { RequestCallComponent } from '../request-call/request-call.component';
import { ModalService } from '../../services/modal.service';
import { AuthenticationService } from '../../../authentication/service/authentication.service';
import { PolicyService } from '../../../policy/services/policy.service';
import { AnimationOptions } from 'ngx-lottie';
import { scrollToItem } from '../../utilities';
import { expand } from 'rxjs/operators';
import { StorageService } from '../../services/storage.service';



declare const accounting: any;
declare const Tawk_API: any;
declare const $: any;

declare function initTooltips(): any;

declare function notify(): any;

declare function smartlook(c: string, d: string, a: any): any;
declare function smartlook(c: string, a: any): any;

declare function initNavPositioning(): any;

declare const CueWidget: any 
declare global {
  interface Window {
    angularComponentReference: any;
    dataLayer: any[];
  }
}

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    providers: [TitleCasePipe],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('requestCallComponent', { static: false })
  requestCallComponent: RequestCallComponent;
  subscription: Subscription;
  inProgress = environment.inProgress;
  production = environment.production;
  server = environment.cssURL;
  version = environment.appVersion;
  NavbarType = NavbarType;
  navType = NavbarType.LoggedOut;
  displayLoggedOutBanner = true;
  policy: any;
  category: any;
  accounting: any;
  chat: any;
  cueDesk: any;
  notify: any;
  unreadNotificationCount = 0;
  initTooltips: any;
  person: any;
  policySummary = [];
  randsTotal = '';
  emergencyCode = 0;
  policyHolderName = '';
  policyProduct = '';
  quoteCategory = 5;
  underwriterCondition!: UnderwriterSchedule;
  RouterLinks = RouterLinks;
  sessionDetails: any;
  change_detector: any;
  navbar_base_crumb = '';
  navbar_breadcrub = '';
  navbar_base_link = '#';
  navbar_close_button_link = '';
  flow_type_id: any;
  pageInfo: any;
  entryType = EntryType;
  sectionType = SectionType;
  documentPageRoute = '';
  fromEditItemFlow = false;
  documentPageSubscription: Subscription;
  sessionDetailsSubscription: Subscription;
  getPageInfoSubscription: Subscription;
  quoteScheduleTotalSubscription: Subscription;
  policyScheduleQuerySubscription: Subscription;
  header_html = '';
  partner_html = '';
  partner_type = '';
  partner_img = '';
  thisPage = '';
  overflowMenuOpen = false;
  downloadQuote = false;
  mode = '';
  chats = [];
  index = 1;
  private helpOutsideClickListener: any;
  private overflowOutsideClickListener: any;

  options: AnimationOptions = {
    path: 'assets/evi-icon.json',
  };
  //window: any['dataLayer'] = window['dataLayer'] || [];
  quoteUrl = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public router: Router,
    private location: Location,
    private policyQuery: PolicyQuery,
    private underwriterQuery: UnderwriterQuery,
    private routerQuery: RouterQuery,
    private userStore: UserStore,
    private policyScheduleQuery: PolicyScheduleQuery,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private componentsService: ComponentsService,
    private questionStore: QuestionStore,
    private claimStore: ClaimStore,
    private flowPlayer: FlowPlayerService,
    public globalQuestionService: GlobalQuestionService,
    public policyService: PolicyService,
    private modalService: ModalService,
    public titleCasePipe: TitleCasePipe,
    private ref: ChangeDetectorRef,
    private authService: AuthenticationService,
    private claimGuardService: ClaimGuardService,
    private storageService: StorageService
  ) {
    
  }

  ngOnInit(): void {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
    this.person = this.userStore.getValue();
    this.globalQuestionService.unreadNotificationCount.subscribe(c => this.unreadNotificationCount = c);
    this.notify = notify();
    this.initTooltips = initTooltips();
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      },
    };
    this.accounting = accounting;
    this.chat = Tawk_API;
    

    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationEnd) {
        this.sessionDetails = this.questionFlowSessionQuery.getValue();
        this.emergencyCode = this.sessionDetails?.emergency_code;
        this.mode = this.storageService.get('mode', 'flow');
        this.documentPageRoute = this.storageService.get('previous-document-page', 'flow');
        if (!this.documentPageRoute) {
          this.documentPageRoute = RouterLinks.PolicyResources;
        }

        let page = ev.url.replace('/', '');
        if (page.indexOf('?') > -1) {
          page = page.substring(0, page.indexOf('?'));
        }
        this.thisPage = page;
        $('.modal').modal('hide');
        this.closeOpenDropdowns();
        this.globalQuestionService.getPageInfo(page);
        $('#overview-sub-3').addClass('d-none');
        setTimeout(() => {
          this.globalQuestionService.initPopoverCustomize();
          //this.cueDesk = CueWidget;
        }, 1000);
      }
    });
    this.getPageInfoSubscription =
      this.globalQuestionService.pageInfoObservable.subscribe((info) => {
        if (info) {
          this.pageInfo = info;
          this.quoteUrl = `./${RouterLinks.PolicyQuoteSchedule}?quote_id=${this.pageInfo[0]?.quote_id}&print=false&pdf=true`;
          this.navType = null;
          this.loadClasses(this.router?.url);
        }
      });

    this.sessionDetailsSubscription = this.questionFlowSessionQuery
      .select()
      .subscribe((x) => {
        this.sessionDetails = x;
        
       
        this.emergencyCode = this.sessionDetails?.emergency_code;
        this.documentPageRoute = this.storageService.get('previous-document-page', 'flow');
        if (!this.documentPageRoute) {
          this.documentPageRoute = RouterLinks.PolicyResources;
        }

        let page = this.router?.url.replace('/', '');
        if (page.indexOf('?') > -1) {
          page = page.substring(0, page.indexOf('?'));
        }
        if (environment.production){
          smartlook('identify', this.sessionDetails?.session_id, {"person_id":this.person?.person_id});
          smartlook('record', { forms: true, numbers: true, emails: false, ips: true })
        }
        
        // Sentry.setTag("session_id", this.sessionDetails?.session_id);
        // Sentry.setTag("person_id", this.person?.person_id);
        // setTimeout(() => {
        //   this.chat.setAttributes({
        //      'name': this.person?.first_name,
        //      'email': this.person?.person_email,
        //   }, function (error) { 
            
        //   });
        //   this.chat.addTags([
        //     'session_id: ' + this.sessionDetails?.session_id,
        //     'person_id: ' + this.person?.person_id,
        //     'category_id: ' + this.sessionDetails?.category_id
        //   ],
        //     function (error) {
              
        //     });
        // }, 5000);
      });

    this.policyScheduleQuery.getSummaryItem().subscribe((item) => {
      this.policySummary = [];
      if (item[0]?.schedule) {
        this.policySummary = item[0]?.schedule;
      }

      const prem = item[0]?.schedule?.find(
        (itemFilter: any) => itemFilter?.header === 'Policy Total'
      )?.premium;
      this.randsTotal = prem ? prem : '0.00';
      this.randsTotal =
        this.randsTotal.substring(0, 1) +
        ' ' +
        this.randsTotal.substring(1, this.randsTotal.length);
    });

    this.quoteScheduleTotalSubscription =
      this.policyService.quoteScheduleTotalObservable.subscribe({
        next: (value) => {
          this.randsTotal = value;
        },
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.sessionDetails?.session_id.toString());
      this.globalQuestionService.runCommandNew(`[getChats]`, parameters).subscribe((chats) => {
        this.chats = chats;

        if (this.chats.length > 0) {
          this.index = this.chats[this.chats.length - 1].chat_index + 1;
        }

      })
      
    }, 5000);
  }

  loadClasses(router: any): void {
    this.person = this.userStore.getValue();
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
    // this.ref.detectChanges();
    const url = router?.url ? router?.url : router;

    this.header_html = '';
    this.partner_html = '';

    this.downloadQuote = !!(
      url?.includes(RouterLinks.QuotePickCover) ||
      url?.includes(RouterLinks.QuoteConfirmCover) ||
      url?.includes(RouterLinks.QuoteConfirmCoverChanges) ||
      url?.includes(RouterLinks.QuoteCustomizeCover) ||
      url?.includes(RouterLinks.QuoteUWPage) ||
      url?.includes(RouterLinks.QuoteUWPageUnpayable) ||
      url?.includes(RouterLinks.QuoteUWPageSubmitted) ||
      url?.includes(RouterLinks.QuotePayCover)
    );
    if (
      url?.includes(RouterLinks.PolicyOverview) ||
      url?.includes(RouterLinks.PolicySummary) ||
      url?.includes(RouterLinks.PolicyAddons) ||
      url?.includes(RouterLinks.PolicyResources) ||
      url?.includes(RouterLinks.Referrals) ||
      url?.includes(RouterLinks.MembershipOverview) ||
      url?.includes(RouterLinks.PolicyInsuredItems) ||
      url?.includes(RouterLinks.PolicyPayment) ||
      url?.includes(RouterLinks.PolicyTranscript) ||
      url?.includes(RouterLinks.ClaimTranscript) ||
      url?.includes(RouterLinks.PolicyEdit)
    ) {
      this.policy = this.policyQuery.getActive();
      
    }
    this.category = this.sessionDetails?.css;

    // if there's an active policy set the css to that, little hack :)
    if ((this.person.broker_id > 0 || this.person.console_access)  && this.policy && !this.category) {
      this.category = this.policy?.category_name.substring(0, this.policy?.category_name.indexOf('.')).toLowerCase();
    }

    // if broker is logged on
    if ((this.person.broker_id > 0 || this.person.console_access)  && this.sessionDetails?.css) {
      this.category = this.sessionDetails?.css;
      
    }

    // if broker is logged on and not doing a quote
    if ((this.person.broker_id > 0 || this.person.console_access) && !url?.includes(RouterLinks.QuestionFlow) && this.policy) {
      this.category = this.policy?.category_name.substring(0, this.policy?.category_name.indexOf('.')).toLowerCase();
      
    }
    
    try {
      if (this.thisPage) {
        let userid = '';
        if (this.person.person_id > 0) {
          userid = this.person.person_id;
        }
        window['dataLayer'].push({
          event: 'pageLoad',
          virtualPageUrl: this.thisPage,
          virtualPageTitle: this.thisPage,
          userId: userid,
          profile: 'Individual',
          category: this.category,
        });
      }
    } catch (e) {
      console.log(e);
    }

    document.querySelector('body')?.removeAttribute('class');
    

    if (
      url?.includes(RouterLinks.CreatePassword) ||
      url?.includes(RouterLinks.SignUp) ||
      url?.includes(RouterLinks.SignUpEmail) ||
      url?.includes(RouterLinks.Login) ||
      url?.includes(RouterLinks.CheckToken) ||
      url === '/' ||
      url?.includes(RouterLinks.ForgotPassword) ||
      url?.includes(RouterLinks.ForgotPasswordLink) ||
      url?.includes(RouterLinks.ResetPassword)
    ) {
      this.displayLoggedOutBanner = true;
      this.navType = NavbarType.LoggedOut;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--login');
    } else if (
      url?.includes(RouterLinks.PolicySchedule) ||
      url?.includes(RouterLinks.PolicyQuoteSchedule)
    ) {
      if (url?.includes(RouterLinks.PolicyWording)) {
        this.navType = NavbarType.PolicyWording;
      } else if (url?.includes(RouterLinks.PolicySchedule)) {
        this.navType = NavbarType.PolicySchedule;
      } else if (url?.includes(RouterLinks.PolicyQuoteSchedule)) {
        this.navType = NavbarType.PolicyQuoteSchedule;
      } else {
        this.navType = NavbarType.PolicyQuoteSchedule;
        this.documentPageRoute = RouterLinks.QuoteLanding;
      }
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central-docs');
      document.querySelector('body')?.classList.add('page--central-sub');
      document.querySelector('body')?.classList.add('policy-tray-active');
      if (url?.includes(RouterLinks.PolicyQuoteSchedule)){
        document.querySelector('body')?.classList.add('page--central');
        document.querySelector('body')?.classList.add('page--pdf-view');
        document.querySelector('body')?.classList.remove('page--central-docs');
        document.querySelector('body')?.classList.remove('page--central-sub');
        document.querySelector('body')?.classList.remove('policy-tray-active');
        document.querySelector('body')?.classList.remove('page--category-' + this.category);
      }
      // if (this.category?.length > 0) {
      //   document
      //     .querySelector('body')
      //     ?.classList.add('page--category-' + this.category);
      // }
    } else if (url?.includes(RouterLinks.PolicyUnderwriters)) {
      this.navType = NavbarType.PolicyUnderwriters;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--underwriting');
      document.querySelector('body')?.classList.add('page--underwriting-tray');
    } else if (
      url?.includes(RouterLinks.UnderwriterLanding) ||
      url?.includes(RouterLinks.UnderwriterPolicyCondition) ||
      url?.includes(RouterLinks.UnderwriterPolicyConditionClasses) ||
      url?.includes(RouterLinks.UnderwriterPolicyConditionInfoRequested) ||
      url?.includes(RouterLinks.UnderwriterPolicyViewTranscript)
    ) {
      this.policyHolderName = '';
      this.policyProduct = '';

      combineLatest([
        this.underwriterQuery.getPolicyHolderDetails(),
        this.routerQuery.selectNavigationExtras(),
      ]).subscribe((detail: any) => {
        const [holderDetails, routerExtras] = detail;
        if (!holderDetails?.length) {
          return;
        }

        if (holderDetails[0]?.schedule?.length === 0) {
          return;
        }
        this.policyHolderName = `${holderDetails[0]?.schedule[0]['first name']} ${holderDetails[0]?.schedule[0]['last name']}`;
        this.policyProduct = this.policy?.product_name;
        this.underwriterCondition = routerExtras?.underwriterChild;
      });

      this.navType = NavbarType.BrokerUnderwriterLanding;

      if (
        url?.includes(RouterLinks.UnderwriterPolicyCondition) ||
        url?.includes(RouterLinks.UnderwriterPolicyConditionClasses) ||
        url?.includes(RouterLinks.UnderwriterPolicyConditionInfoRequested) ||
        url?.includes(RouterLinks.UnderwriterPolicyViewTranscript)
      ) {
        this.navType = NavbarType.BrokerUnderwriterCondition;
      }

      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--underwriting');
      document.querySelector('body')?.classList.add('page--underwriting-tray');
    } else if (
      url?.includes(RouterLinks.PolicyHolders) ||
      url?.includes(RouterLinks.BrokerResources)
    ) {
      this.navType = NavbarType.LoggedIn;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--underwriting');
    } else if (url?.includes(RouterLinks.PolicyEditSummary)) {
      this.navType = NavbarType.PolicyEditSummary;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
      document.querySelector('body')?.classList.add('page--central-tray');
    } else if (url?.includes(RouterLinks.PolicyEdit)) {
      this.navType = NavbarType.PolicyEdit;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
      document.querySelector('body')?.classList.add('page--central-tray');
    } else if (url?.includes(RouterLinks.QuoteQuestions)) {
      this.navType = NavbarType.QuoteQuestions;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quotes');
      document.querySelector('body')?.classList.add('page--quotes-no-tray');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuoteWizard)) {
      this.navType = NavbarType.QuoteWizard;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quotes');
      document.querySelector('body')?.classList.add('page--quotes-no-tray');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
      // MR20260922: let the standard claims nav (breadcrumbs + sidebar) handle the emergency question-flow too, matching the updated control in https://everything.awebster.co.za/pages/everything.claims-security-code.html
    } else if (url?.includes(RouterLinks.QuestionFlow)) {
      const current_flow: any = this.questionFlowSessionQuery.getValue();
      this.flow_type_id = current_flow?.flow_type_id;
      this.fromEditItemFlow = this.storageService.get('edit-item-flow', 'flow') === 'true';
      if (current_flow?.flow_type_id !== 2) {
        this.navbar_base_crumb = 'Quote';
        this.navbar_breadcrub =
          this.globalQuestionService?.getSection('header', 'client_name')
            ?.description || 'Start Quote';
        this.category = this.sessionDetails?.css;
        this.navbar_base_link = `/${RouterLinks.QuoteWizard}`;
        this.navbar_close_button_link = '#exit-modal';
      } else if (current_flow?.flow_type_id === 2) {
        this.navbar_base_crumb = 'Claims';
        this.navbar_breadcrub = 'Start Claim';
        this.navbar_close_button_link = '#close-claim-modal';
        this.navbar_base_link = `/${RouterLinks.ClaimsLanding}`;
        this.category = 'everything';
      }

      this.navType = NavbarType.QuestionFlow;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--questions');
      // document.querySelector('body')?.classList.add('page--questions-has-tray');

      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (
      url?.includes(RouterLinks.QuoteUWPage) ||
      url?.includes(RouterLinks.QuoteUWPageUnpayable) ||
      url?.includes(RouterLinks.QuoteUWPageSubmitted)
    ) {
      this.navType = NavbarType.QuoteUWPage;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quote');
      // document.querySelector('body')?.classList.add('page--quote-tray');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuotePickCover)) {
      this.navType = NavbarType.QuotePickCover;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quote');
      document.querySelector('body')?.classList.add('summary-tray-active');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuoteConfirmCoverChanges)) {
      this.navType = NavbarType.QuoteConfirmCoverChanges;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quote');
      document.querySelector('body')?.classList.add('page--quote-centered');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuoteConfirmCover)) {
      this.navType = NavbarType.QuoteConfirmCover;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quote');
      document.querySelector('body')?.classList.add('summary-tray-active');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuoteCustomizeCover)) {
      this.navType = NavbarType.QuoteCustomizeCover;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quote');
      document.querySelector('body')?.classList.add('summary-tray-active');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuotePayCover)) {
      this.navType = NavbarType.QuotePayCover;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quote');
      document.querySelector('body')?.classList.add('summary-tray-active');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuoteUnderwriting)) {
      this.navType = NavbarType.QuoteUnderwriting;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quote');
      document.querySelector('body')?.classList.add('page--quote-no-steps');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.QuoteCovered)) {
      setTimeout(() => {
        this.navType = NavbarType.QuoteCovered;
      }, 0);
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--questions');
      document.querySelector('body')?.classList.add('page--questions-no-tray');
      // if (this.category?.length > 0) {
      //   document
      //     .querySelector('body')
      //     ?.classList.add('page--category-' + this.category);
      // }
    } else if (url?.includes(RouterLinks.PolicyOverviewEdit)) {
      this.navType = NavbarType.PolicyOverviewEdit;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
      document.querySelector('body')?.classList.add('page--central-tray');
    } else if (
      url?.includes(RouterLinks.PolicyOverview) ||
      url?.includes(RouterLinks.PolicySummary) ||
      url?.includes(RouterLinks.PolicyAddons) ||
      url?.includes(RouterLinks.Referrals) ||
      url?.includes(RouterLinks.PolicyInsuredItems) ||
      url?.includes(RouterLinks.PolicyResources) ||
      url?.includes(RouterLinks.PolicyPayment) ||
      url?.includes(RouterLinks.Documents) ||
      url?.includes(RouterLinks.MembershipOverview)
    ) {
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central');
      document.querySelector('body')?.classList.add('page--central-sub');
      this.navType = NavbarType.LoggedIn;
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (
      url?.includes(RouterLinks.EmergencyAssistProductSelect) ||
      url?.includes(RouterLinks.EmergencyAssistLocation) ||
      url?.includes(RouterLinks.EmergencyAssistLocateMe) ||
      url?.includes(RouterLinks.EmergencyAssistAssistCode)
    ) {
      this.navType = NavbarType.EmergencyAssist;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--claims');
    } else if (url?.includes(RouterLinks.EmergencyAssistCancelProduct)) {
      this.navType = NavbarType.EmergencyAssistCancel;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--claims');
    } else if (url?.includes(RouterLinks.ProcessClaim)) {
      this.navType = NavbarType.Claim;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--claims');
      document.querySelector('body')?.classList.add('page--category-personal');
    } else if (
      url?.includes(RouterLinks.ClaimSummary) &&
      !url?.includes(RouterLinks.ClaimSummaryUpdate) &&
      !this.emergencyCode
    ) {
      this.navType = NavbarType.ClaimSummary;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--claims');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (
      url?.includes(RouterLinks.ClaimSummaryUpdate) &&
      !this.emergencyCode
    ) {
      this.navType = NavbarType.ClaimSummaryUpdate;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--claims');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.ClaimEdit)) {
      this.navType = NavbarType.ClaimEdit;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--claims');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }
    } else if (
      url?.includes(RouterLinks.DocsBrokerAppointmentLetter) ||
      url?.includes(RouterLinks.DocsPolicyStatement) ||
      url?.includes(RouterLinks.DocsTaxInvoice) ||
      url?.includes(RouterLinks.DocsDebitOrderAuthority) ||
      url?.includes(RouterLinks.DocsTermsAndCondition) ||
      url?.includes(RouterLinks.DocsPrivacyPolicy) ||
      url?.includes(RouterLinks.DocsProfessionalFeeAgreement) ||
      url?.includes(RouterLinks.DocsCookiesPolicy) ||
      url?.includes(RouterLinks.PolicyTranscript)
    ) {
      this.navType = NavbarType.Documentation;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central-docs');
      document.querySelector('body')?.classList.add('page--central-sub');
      document.querySelector('body')?.classList.add('page--category-personal');
      document.querySelector('body')?.classList.add('policy-tray-active');
    } else if (url?.includes(RouterLinks.DealAlert)) {
      this.navType = NavbarType.DealAlert;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central');
      document.querySelector('body')?.classList.add('page--central-deal-tray');
      document.querySelector('body')?.classList.add('page--category-personal');
    } else if (
      url?.includes(RouterLinks.PolicyConfirmationOfCover) ||
      url?.includes(RouterLinks.PolicyCertificateOfCover) ||
      url?.includes(RouterLinks.DocDocument) ||
      url?.includes(RouterLinks.PolicyPDFSchedule) ||
      url?.includes(RouterLinks.PolicyQuoteSchedule) ||
      url?.includes(RouterLinks.PolicyVersion) ||
      url?.includes(RouterLinks.PolicyWording) ||
      url?.includes(RouterLinks.ClaimTranscript) 
    ) {
        document.querySelector('body')?.classList.add('page');
        document.querySelector('body')?.classList.add('page--pdf-view');
        document.querySelector('body')?.classList.add('page--central');
      
    } else if (
      (url?.includes(RouterLinks.QuestionFlow) ||
        (url?.includes(RouterLinks.ClaimSummary) &&
          !url?.includes(RouterLinks.ClaimSummaryUpdate)) ||
        url?.includes(RouterLinks.ClaimSummaryUpdate)) &&
      this.emergencyCode
    ) {
      this.navType = NavbarType.EmergencyAssist;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--claims');
      document.querySelector('body')?.classList.add('page--questions-has-tray');
      document.querySelector('body')?.classList.add('page--claims-code');
      if (this.category?.length > 0) {
        document
          .querySelector('body')
          ?.classList.add('page--category-' + this.category);
      }

    } else if (url?.includes(RouterLinks.ComplianceVault) || url?.includes(RouterLinks.EditProfile)) {
      this.navType = NavbarType.ComplianceVault;
      this.policy = this.policyQuery.getActive();
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central');
      document.querySelector('body')?.classList.add('page--central-tray');
    } else if (url?.includes(RouterLinks.QuoteChangeProduct) || url?.includes(RouterLinks.QuoteChangeBenefits)) {
      //this.navType = NavbarType.ComplianceVault;
      this.policy = this.policyQuery.getActive();
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--quotes-renew');
      document.querySelector('body')?.classList.add('page--quotes-renew-tray');
      if (this.category?.length > 0) {
        document.querySelector('body')?.classList.add('page--category-' + this.category);
      }
    } else if (url?.includes(RouterLinks.Account)) {
      this.navType = null;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central');
      document.querySelector('body')?.classList.add('page--central-tray');
    }  else if (url?.includes(RouterLinks.PolicyStatement)) {
      this.navType = null;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--central-nicedocs');
      document.querySelector('body')?.classList.add('page--central-sub');
    }  else {
      document.querySelector('body')?.classList.add('page');
      if (!url?.includes(RouterLinks.QuoteQuestions)) {
        this.navType = NavbarType.LoggedIn;
        document.querySelector('body')?.classList.add('page--central');
        if (this.category?.length > 0) {
          document
            .querySelector('body')
            ?.classList.add('page--category-' + this.category);
        }
      }

      if (
        url?.includes(RouterLinks.PoliciesLanding) ||
        url?.includes(RouterLinks.QuoteLanding) ||
        url?.includes(RouterLinks.MembershipLanding) ||
        url?.includes(RouterLinks.ClaimsLanding) ||
        url?.includes(RouterLinks.DashboardLanding) ||
        url?.includes(RouterLinks.BrokerDashboard) ||
        // url?.includes(RouterLinks.QuestionFlow) ||
        url?.includes(RouterLinks.Account)
      ) {
        document
          .querySelector('body')
          ?.classList.remove('page--category-' + this.category);
          document.querySelector('body')?.classList.add('page--questions-has-tray');
      }
    }

    /* templates that have central sidebar nav */
    if (
      url?.includes(RouterLinks.PoliciesLanding) ||
      url?.includes(RouterLinks.QuoteLanding) ||
      url?.includes(RouterLinks.MembershipLanding) ||
      url?.includes(RouterLinks.ClaimsLanding) ||
      url?.includes(RouterLinks.DashboardLanding) ||
      url?.includes(RouterLinks.PolicyOverview) ||
      url?.includes(RouterLinks.Referrals) ||
      url?.includes(RouterLinks.PolicySummary) ||
      url?.includes(RouterLinks.PolicyInsuredItems) ||
      //url?.includes(RouterLinks.PolicyInsuredItemsDetail) ||
      url?.includes(RouterLinks.PolicyAddons) ||
      url?.includes(RouterLinks.PolicyPayment) ||
      url?.includes(RouterLinks.PolicyResources) ||
      url?.includes(RouterLinks.MembershipAddons) ||
      url?.includes(RouterLinks.MembershipResources) ||
      url?.includes(RouterLinks.MembershipInsuredItems)
    ) {
      document.querySelector('body')?.classList.add('has-sidemenu');
      document.querySelector('body')?.classList.add('page--central-landing');
    }
    if (url?.includes(RouterLinks.PolicyInsuredItemsDetail)){
      document.querySelector('body')?.classList.add('page--category-' + this.category);
      document.querySelector('body')?.classList.add('page--central-sub-sub');
      document.querySelector('body')?.classList.remove('page--central-sub');
      document.querySelector('body')?.classList.remove('has-sidemenu');
      document.querySelector('body')?.classList.remove('page--central-landing');
    }
    if (url?.includes(RouterLinks.ComplianceVault)){
      document.querySelector('body')?.classList.remove('page--category-' + this.category);
    }
    if (url?.includes(RouterLinks.Referrals)){
      document.querySelector('body')?.classList.add('has-scrollnav');
    }
    if (url?.includes(RouterLinks.Documents)){
      document.querySelector('body')?.classList.add('has-appbar');
    }
    if (url?.includes(RouterLinks.CommercialAddLocation)){
      this.navType = NavbarType.QuestionFlow;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--questions');
      // document.querySelector('body')?.classList.add('page--questions-has-tray');
      document.querySelector('body')?.classList.remove('page--central');
    }
    if (url?.includes(RouterLinks.QuoteOutstanding)){
      this.navType = NavbarType.QuoteOutstanding;
      document.querySelector('body')?.classList.add('page');
      document.querySelector('body')?.classList.add('page--questions');
      document.querySelector('body')?.classList.remove('page--central');
    }

     // MR20260922: exclude question-flow so the now-reachable QuestionFlow navType above doesn't trigger this padding offset mid-flow (the .emergency-bar element it makes room for has no template anywhere in the app)
    if (this.sessionDetails?.emergency_code > 0 && this.navType !== NavbarType.EmergencyAssist && !url?.includes(RouterLinks.QuestionFlow)) {
      document.querySelector('body')?.classList.add('emergency-bar-active');
    }
    this.checkPartnerCode();

    setTimeout(() => {
      $('[data-tooltip="tooltip"]').tooltip();
    }, 500);
  }

  ngOnChanges(): void {
    console.log();
  }

  checkPartnerCode(): void {
    this.header_html = '';
    this.partner_html = '';

    if (this.pageInfo) {
      const info = this.globalQuestionService?.getSection(
        SectionType.header,
        EntryType.header_logo
      );
      this.partner_type = info?.partner_type;
      this.partner_img = info?.img_path;
      this.header_html = info?.header_html;
      this.partner_html = info?.partner_html;

      switch (this.thisPage) {
        case this.RouterLinks.QuoteWizard:
        case this.RouterLinks.QuestionFlow:
          // within question flow
          // remove partner bar if lite and logged in
          if (this.person.person_id > 0 && this.partner_type === 'lite') {
            this.partner_html = '';
          }

          if (this.partner_html && this.partner_html !== '') {
            if (this.partner_type === 'lite') {
              document
                .querySelector('body')
                ?.classList.add('partner-bar-active');
            }
            if (this.partner_type === 'full') {
              document
                .querySelector('body')
                ?.classList.add('partner-bar-full-active');
            }
          }

          break;
        default:
          if (this.partner_html && this.partner_html !== '') {
            if (this.partner_type === 'lite') {
              document
                .querySelector('body')
                ?.classList.add('partner-bar-active');
            }
            if (this.partner_type === 'full') {
              document
                .querySelector('body')
                ?.classList.add('partner-bar-full-active');
            }
          }
          break;
      }
    } else {
      document.querySelector('body')?.classList.remove('partner-bar-active');
      document
        .querySelector('body')
        ?.classList.remove('partner-bar-full-active');
      this.header_html = '';
      this.partner_html = '';
    }
    // this.ref.detectChanges();
  }

  requestCall(): void {
    this.requestCallComponent.showModal(this.person);
  }

  openProfileMenu(): void {
    const modal = $('#modal-traymenu-profile');
    modal.removeClass('show').attr('aria-hidden', 'true').css('display', '');
    modal.removeData('bs.modal');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css('padding-right', '');
    modal.modal('show');
  }

  // bootstrap only closes a menu whose toggle still carries its `bs.dropdown` data, so a toggle
  // re-created by *ngIf during navigation leaves the menu open. Force any open menu shut instead.
  closeOpenDropdowns(): void {
    $('.dropdown-menu.show')
      .not('.dropdown--persist .dropdown-menu') // filter/chat menus are meant to stay open
      .toArray()
      .forEach((element: any) => {
        const menu = $(element);
        const parent = menu.parent();
        // let bootstrap fire hidden.bs.dropdown where it can, so backdrops get cleaned up
        parent
          .find('[data-toggle="dropdown"]')
          .first()
          .dropdown('hide')
          .attr('aria-expanded', 'false');
        menu.removeClass('show');
        parent.removeClass('show');
      });
  }

  closeProfileAndNavigate(route: string): void {
    const modal = $('#modal-traymenu-profile');
    modal.one('hidden.bs.modal', () => this.setRoute(route));
    modal.modal('hide');
  }

  closeProfileAndLogout(): void {
    const modal = $('#modal-traymenu-profile');
    modal.one('hidden.bs.modal', () => this.logout());
    modal.modal('hide');
  }

  back(): void {
    this.location.back();
  }

  // Mirrors ClaimEditModalComponent.back() (its Cancel button) - the navbar's X on the
  // claim-edit page is a separate element outside that component so it can't call its
  // method directly, but it should behave identically rather than just popping history.
  closeClaimEdit(): void {

    this.globalQuestionService.evaluateClaimCompletionStatus()
      .subscribe(() => {

        const route = this.storageService.get('previous-document-page', 'flow');
        // Arriving here from the in-flow claims-summary-update question should return to
        // claims-summary on close, matching what that question's own Cancel/Save
        // (QuestionClaimSummaryUpdateComponent.back()) already does - previous-document-page
        // alone isn't reliable for this case, so check for it explicitly.
        if (route?.includes(RouterLinks.ClaimSummaryUpdate)) {
          this.router.navigate([`/${RouterLinks.ClaimSummary}`]);
        } else if (route) {
          this.router.navigate([`/${route}`]);
        } else {
          this.router.navigate([`/${RouterLinks.ClaimsLanding}`]);
        }
      });
  }
  changePassword(): void {
    this.storageService.set('previous-document-page', this.router.url, 'flow');
    this.router.navigate(['/change-password']);
  }

  logout(): void {
    this.displayLoggedOutBanner = true;
    this.navType = NavbarType.LoggedOut;
    this.userStore.reset();
    this.authService.stopRefreshTokenTimer();
    this.storageService.remove('rememberMe', 'user');
    this.storageService.remove('partner_code', 'flow');
    this.storageService.remove('userlogin', 'user'),
      this.storageService.set('loggedOut', 'true', 'user');
    //remove eviSessionId cookie
    document.cookie = 'eviSessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    this.router.navigate(['/login']);
  }

  comingSoon(): void {
    this.notify.init({
      message: '<strong>Coming Soon! &#128522;</strong>', // required
      icon: 'info', // default: null; options: 'info', 'complete', or any icon-name really
      size: 'lg', // default: null; options: 'lg'
      style: 'info', // default: null; options: 'info', 'success',
      close: true, // default: false (close button enabled, auto-close duration removed)
      speed: 350, // default: 350 (fade in/out speed)
      duration: 5000, // default: 5000 (duration active)
    });
  }
 setRoute(route: any): void{
  this.storageService.set('previous-document-page', this.router.url, 'flow');
    this.router.navigate(['/'+route]);

 }
  ngOnDestroy(): void {
    this.policyScheduleQuerySubscription?.unsubscribe();
    this.subscription?.unsubscribe();
    this.documentPageSubscription?.unsubscribe();
    this.sessionDetailsSubscription?.unsubscribe();
    this.quoteScheduleTotalSubscription?.unsubscribe();
    this.getPageInfoSubscription?.unsubscribe();
    this.removeHelpOutsideClickListener();
    this.removeOverflowOutsideClickListener();
  }

  resetQuoteStore(): void {
    this.questionStore.reset();
    if (this.person.person_id !== 0) {
      if (this.person.broker_id > 0 || this.person.console_access) {
        this.router.navigate(['/everything.policy-holders']);
      } else {
        this.router.navigate(['/quote-landing']);
      }
    } else {
      const partner_code = this.storageService.get('partner_code', 'flow');
      if (partner_code) {
        this.router.navigate(['/quote-wizard'], {
          queryParams: { partner_code },
        });
      } else {
        this.router.navigate(['/quote-wizard']);
      }
    }
  }

  discardQuote(): void {
    const parameters = new Map<string, string>();
    parameters.set('new_session_id', this.sessionDetails.session_id);
    this.globalQuestionService
      .runCommandNew('removeQuote', parameters)
      .subscribe(
        () => {},
        (error: any) => {
          console.log(error);
        }
      );
    this.questionStore.reset();
    const partner_code = this.storageService.get('partner_code', 'flow');
    if (this.documentPageRoute && this.person.person_id !== 0) {
      if (this.person.broker_id > 0 || this.person.console_access) {
        this.router.navigate(['/everything.policy-holders']);
      } else {
        this.router.navigate([this.documentPageRoute]);
        this.storageService.remove('previous-document-page', 'flow');
      }
    } else {   
      if (partner_code) {
        this.router.navigate(['/quote-wizard'], {
          queryParams: { partner_code },
        });
      } else {
        this.router.navigate(['/quote-wizard']);
      }
    }
  }

  closeEditItemFlow(): void {
    const policy_id = this.storageService.get('edit-item-flow-policy-id', 'flow') || this.policyQuery.getActiveId()?.toString();
    const curr_session_id = this.storageService.get('edit-item-flow-session-id', 'flow') || this.sessionDetails?.session_id;
    const parameters = new Map<string, string>();
    parameters.set('policy_id', policy_id);
    parameters.set('curr_session_id', curr_session_id);
    parameters.set('select', '0');
    parameters.set('rollback', '1');
    parameters.set('rollback_v2', '1');
    this.globalQuestionService.runCommandNew('editPolicy', parameters).subscribe(() => {
      this.questionStore.reset();
      this.storageService.remove('edit-item-flow', 'flow');
      this.storageService.remove('edit-item-flow-policy-id', 'flow');
      this.storageService.remove('edit-item-flow-session-id', 'flow');
      this.router.navigate([this.documentPageRoute], { state: { edit: true, policy_id } });
    });
  }

  exitClaim(): void {
    this.questionStore.reset();
    if (this.documentPageRoute.includes('policy-edit')){
      this.router.navigate([this.documentPageRoute]);
    }  
    else if (this.person.broker_id > 0 || this.person.console_access) {
      this.router.navigate(['/everything.policy-holders']);
    } else {
        this.router.navigate([RouterLinks.ClaimsLanding]);
      this.storageService.remove('previous-document-page', 'flow');
    }
    this.storageService.remove('context_person_id', 'user');
    this.storageService.remove('context_person_first_name', 'user');
  }

  closeMenuModal(): void {
    $('#mobile-quote-menu').modal('hide');
    this.storageService.set('previous-document-page', this.router.url, 'flow');
  }

  sendQuote(): void {
    let email = $('.save-email').val();
    let name = '';
    if (email == '') {
      email = this.person.person_email;
      name = this.person.first_name;
    } else {
      // email = $('.save-email').val();
      name = 'Stranger';
    }
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id.toString());
    this.globalQuestionService
      .runCommandNew(`resumeFlow`, parameters)
      .subscribe((flow) => {
        const key = `${this.server}app/${flow[0]?.url}`;
        const newParameters = new Map<string, string>();
        newParameters.set('event_id', '2');
        newParameters.set(
          'session_id',
          this.sessionDetails?.session_id.toString()
        );
        newParameters.set('key', key);
        newParameters.set('email', email);

        this.globalQuestionService
          .runCommandNew(`triggerEvent`, newParameters)
          .subscribe((result) => {
            $('#savequote-modal').modal('hide');
            this.notify.init({
              message: '<strong>Quote email sent. &#128522;</strong>', // required
              icon: 'complete', // default: null; options: 'info', 'complete', or any icon-name really
              size: 'lg', // default: null; options: 'lg'
              style: 'success', // default: null; options: 'info', 'success',
              close: true, // default: false (close button enabled, auto-close duration removed)
              speed: 350, // default: 350 (fade in/out speed)
              duration: 5000, // default: 5000 (duration active)
            });
          });

        // parameters.set('template_code', 'quote_reminder');
        // parameters.set('session_id', this.sessionDetails.session_id.toString());
        // parameters.set('category_id', this.sessionDetails.category_id.toString());
        // parameters.set('group_id', this.sessionDetails.group_id.toString());
        // parameters.set('key', key);
        // parameters.set('ToEmail', email);
        // parameters.set('ToName', name);

        // this.globalQuestionService.runCommandNew(`dbo.sendEmailTemplate`, parameters).subscribe(result => {
        //   $('#savequote-modal').modal('hide');
        //   this.notify.init({
        //     message: '<strong>Quote email sent. &#128522;</strong>', // required
        //     icon: 'complete',   // default: null; options: 'info', 'complete', or any icon-name really
        //     size: 'lg',     // default: null; options: 'lg'
        //     style: 'success',  // default: null; options: 'info', 'success',
        //     close: true,    // default: false (close button enabled, auto-close duration removed)
        //     speed: 350,     // default: 350 (fade in/out speed)
        //     duration: 5000  // default: 5000 (duration active)
        //   });
        // });
      });
  }

  startSOSFlow(): void {
    this.claimStore.reset();
    this.storageService.set('previous-document-page', this.router.url, 'flow');
    this.closeHelpSidesheet();
    // no policy context here, so the claimant is the logged-in user. Without an
    // explicit person_id the guard checks person_id 0 and never fires.
    this.claimGuardService
      .startClaimFlow(null, 0, 0, 0, this.person?.person_id)
      .subscribe((result: any) => {
        if (!result) {
          return;
        }
        if (result[0]?.next_superflow) {
          this.flowPlayer.startSuperFlow(
            result[0]?.next_superflow,
            0,
            0,
            0,
            '0',
            '',
            ''
          );
        }
      });
  }
  startClaim(): void{
    // no policy context here, so the claimant is the logged-in user.
    this.claimGuardService.startClaimFlow(null, 0, 0, 0, this.person?.person_id)
      .subscribe((result: any) => {
        if (!result) {
          return;
        }
        if (result[0]?.next_superflow) {
            this.flowPlayer.startSuperFlow(result[0]?.next_superflow, 0, 0, 0, '0', '', 'central');
        }
      });
  }

  openClaimsEditModalMobileModal(): void {
    this.modalService.setClaimsEditModalMobileModalSubject(true);
  }
  backToOverview(): void {
    if (this.thisPage === RouterLinks.Documents || this.thisPage === RouterLinks.DocumentsGeneral || this.thisPage === RouterLinks.PolicyDocuments){
      window.history.back();
    }
    else{
      this.router.navigate([RouterLinks.PolicyOverview])
    }
    
    $('.summary-card').removeClass('d-none');
    $('.central-nav-mobile').removeClass('d-none');
    $('#overview-sub-1').removeClass('d-none');
    $('.notice').removeClass('d-none');

    $('.policy-grid').addClass('d-none');
    $('#overview-sub-2').addClass('d-none');
    $('#overview-sub-3').addClass('d-none');
  }
  openChat(): void{
    this.chat.toggle();
   
  }
  openWhatsApp(): void {
    this.cueDesk.openWidget();
  }
  // True while the console/broker user is anywhere under the console side of the
  // app - the policy-holders/broker-dashboard landing pages themselves, or any
  // policy drilled into from there (person_id on the active policy won't match
  // the logged-in console/broker's own person_id). Route alone can't tell these
  // apart since personal and console views share the same policy page routes.
  checkBrokerView(): boolean {
    if (this.thisPage === this.RouterLinks.PolicyHolders || this.thisPage === this.RouterLinks.BrokerDashboard) {
      return true;
    }
    if (!(this.person?.broker_id > 0 || this.person?.console_access)) {
      return false;
    }
    const activePolicy = this.policyQuery.getActive();
    const holderPersonId = activePolicy?.person?.[0]?.person_id;
    return !!holderPersonId && holderPersonId !== this.person?.person_id;
  }
  openSidesheet(): void {
    const sidesheetEl = document.querySelector('#filters-sidesheet');
    sidesheetEl.classList.add('is-active');
    document.body.classList.add('sidesheet-open');
  }
  toggleOverflowMenu(): void {
    if (this.overflowMenuOpen) {
      this.closeOverflowMenu();
      return;
    }

    this.overflowMenuOpen = true;
    this.removeOverflowOutsideClickListener();

    const overflowMenuEl = document.querySelector('.navbar-overflow-menu');
    if (!overflowMenuEl) {
      return;
    }

    // Ignore the opening click, then close on any later outside click.
    this.overflowOutsideClickListener = (e: any) => {
      if (
        !overflowMenuEl.contains(e.target) &&
        !e.target?.closest?.('.navbar-actions__item--burger')
      ) {
        this.closeOverflowMenu();
      }
    };
    document.addEventListener('click', this.overflowOutsideClickListener);
  }
  closeOverflowMenu(): void {
    this.overflowMenuOpen = false;
    this.removeOverflowOutsideClickListener();
  }
  private removeOverflowOutsideClickListener(): void {
    if (this.overflowOutsideClickListener) {
      document.removeEventListener('click', this.overflowOutsideClickListener);
      this.overflowOutsideClickListener = null;
    }
  }
  closeHelpSidesheet(): void {
    const sidesheetEl = document.querySelector('#help-sidesheet');
    sidesheetEl?.classList.remove('is-active');
    document.body.classList.remove('sidesheet-open');
    this.removeHelpOutsideClickListener();
  }
  openHelpSidesheet(): void {
    const sidesheetEl = document.querySelector('#help-sidesheet');
    if (!sidesheetEl) {
      return;
    }
    sidesheetEl.classList.add('is-active');
    document.body.classList.add('sidesheet-open');

    // Close on outside click. Torn down again in closeHelpSidesheet so it can
    // never stack: the old Sidesheet class added one of these per open and never
    // removed it, so stale listeners closed the sheet on the click that opened it.
    // The help-trigger guard is what stops this listener firing on the
    // very click still bubbling up to document.
    this.removeHelpOutsideClickListener();
    this.helpOutsideClickListener = (e: any) => {
      if (
        !sidesheetEl.contains(e.target) &&
        !e.target?.closest?.('.navbar-actions__sos, .navbar-actions__item--sos')
      ) {
        this.closeHelpSidesheet();
      }
    };
    document.addEventListener('click', this.helpOutsideClickListener);
  }
  private removeHelpOutsideClickListener(): void {
    if (this.helpOutsideClickListener) {
      document.removeEventListener('click', this.helpOutsideClickListener);
      this.helpOutsideClickListener = null;
    }
  }

  chatWithEvi(): void {
    this.closeHelpSidesheet();
    this.componentsService.sendEviCommand('expand');
  }

  hasProductTour(): boolean {
    return !!document.getElementById('onboarding-modal');
  }

  replayProductTour(): void {
    this.closeHelpSidesheet();

    const $onboardingModal = $('#onboarding-modal');
    if (!$onboardingModal.length) {
      return;
    }
    const $onboardingSlider = $('#onboarding-slider');
    const $onboardingNextBtn = $('#onboarding-next');
    const $onboardingCount = $('#onboarding-count');
    const slideLength = $onboardingSlider.find('.modal-onboarding__slide').length;

    $onboardingModal.modal('show');

    // on modal load, init slider
    $onboardingModal.off('shown.bs.modal').on('shown.bs.modal', () => {
      $onboardingSlider.not('.slick-initialized').slick({
        initialSlide: 0,
        arrows: false,
        dots: false,
        infinite: false,
        rows: 0,
      });
    });

    $onboardingModal.off('hidden.bs.modal').on('hidden.bs.modal', () => {
      $onboardingSlider.slick('slickGoTo', 0);
      $onboardingSlider.slick('unslick');
    });

    // on 'next' click
    $(document).off('click', '#onboarding-next').on('click', '#onboarding-next', (e) => {
      e.preventDefault();
      $onboardingSlider.slick('slickNext');
    });

    // on change
    $onboardingSlider.off('beforeChange').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      // update counter text
      $onboardingCount.text(nextSlide + 1);

      // update button text
      $onboardingNextBtn.removeAttr('data-dismiss');
      if (nextSlide === slideLength - 1) {
        $onboardingNextBtn.text('Got it').attr('data-dismiss', 'modal');
      } else if (nextSlide >= 1) {
        $onboardingNextBtn.text('Next');
      } else {
        $onboardingNextBtn.text('Let\'s Go');
      }
    });
  }

}
